import { render, staticRenderFns } from "./gift-card.vue?vue&type=template&id=7213fafe&scoped=true"
import script from "./gift-card.vue?vue&type=script&lang=js"
export * from "./gift-card.vue?vue&type=script&lang=js"
import style0 from "./gift-card.vue?vue&type=style&index=0&id=7213fafe&prod&lang=less"
import style1 from "./gift-card.vue?vue&type=style&index=1&id=7213fafe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7213fafe",
  null
  
)

export default component.exports